import { PortfolioAutoComplete } from '@app/occurences/model/portfolio-autocomplete.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, catchError, tap, finalize } from 'rxjs/operators';
import { UtilService } from '@app/shared/utils';
import { OccurencesService } from '@app/occurences/occurences.service';
import { SnackbarService } from '@app/shared/services/snackbar.service';

export enum TypeSearch {
  Name = 'NAME',
  Code = 'CODE',
  CnpjCpf = 'CNPJ_CPF'
}

@Component({
  selector: 'app-occurence-data',
  templateUrl: './occurence-data.component.html',
  styleUrls: ['./occurence-data.component.css']
})

export class OccurenceDataComponent implements OnInit {

  @Input('dataForm')
  public dataForm: FormGroup;

  @Input()
  public isVisualization: boolean;

  public statusDemanda: string = null;

  @Input('value')
  public value: Number = 0;

  @Input()
  public showSelect: boolean;

  @Input()
  formWasSubmited: boolean;

  @Output()
  selectedPortfolio: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  filteredOptions;
  mySelectNameField = new FormControl();
  mySelectCodeField = new FormControl();
  mySelectCnpjCpfField = new FormControl();

  isLoading = false;
  isLoadingPending: Array<Boolean> = new Array<Boolean>();

  showLoading: Boolean = false;
  showPortfolios: Boolean = true;
  havePortfolios: Boolean = false;
  isChangeObject: Boolean = false;
  isValueAutoComplete: Boolean;
  isAutoCompletCalled: Boolean;

  constructor(
    private utils: UtilService,
    private fb: FormBuilder,
    private occurenceService: OccurencesService,
    private _snackbarService: SnackbarService
  ) { }

  ngOnInit() {
    this.isValueAutoComplete = false;
    this.isAutoCompletCalled = false;

    if (this.isVisualization) {
      this.statusDemanda = this.dataForm.get('statusDemanda').value;
      this.disableFields();
    } else {
      this.initMySelectNameField();
      this.initMySelectCodeField();
      this.initMySelectCnpjCpfField();
    }
  }

  initMySelectNameField() {
    this.mySelectNameField.valueChanges
    .pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.threatInitializePortfoliosRequest(TypeSearch.Name);
      }),
      switchMap(value => {
        this.isChangeObject = false;
        this.showPortfolios = true;
        return this.validatePortfoliosRequest(value, TypeSearch.Name);
      })
    ).subscribe(wallets => {

      if (this.showPortfolios === true) {
        this.filteredOptions = wallets;
      }
    });

  }

  initMySelectCodeField() {
    this.mySelectCodeField.valueChanges
    .pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.threatInitializePortfoliosRequest(TypeSearch.Code);
      }),
      switchMap(value => {
        this.isChangeObject = false;
        this.showPortfolios = true;
        return this.validatePortfoliosRequest(value, TypeSearch.Code);
      })
    ).subscribe(wallets => {

      if (this.showPortfolios === true) {
        this.filteredOptions = wallets;
      }
    });

  }

  initMySelectCnpjCpfField() {
    this.mySelectCnpjCpfField.valueChanges
    .pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.threatInitializePortfoliosRequest(TypeSearch.CnpjCpf);
      }),
      switchMap(value => {
        this.isChangeObject = false;
        this.showPortfolios = true;
        return this.validatePortfoliosRequest(value, TypeSearch.CnpjCpf);
      })
    ).subscribe(wallets => {

      if (this.showPortfolios === true) {
        this.filteredOptions = wallets;
      }
    });

  }

  //tslint:disable-next-line: use-life-cycle-interface
  ngOnChanges() {
    if (!this.isVisualization) {
        this.threatNotFoundPortfolio(true);
    }
  }

  threatInitializePortfoliosRequest(typeSearch: TypeSearch): void {

    this.dataForm.get('fName').setValue((<HTMLInputElement>document.getElementById('mySelectNameField')).value);
    this.dataForm.get('fCode').setValue((<HTMLInputElement>document.getElementById('mySelectCodeField')).value);
    this.dataForm.get('fCpfCnpj').setValue((<HTMLInputElement>document.getElementById('mySelectCnpjCpfField')).value);
    this.filteredOptions = [];
    this.isLoading = true;
    this.havePortfolios = true;

    if(this.isValueAutoComplete && !this.isAutoCompletCalled){
      this.isValueAutoComplete = false;
      this.isAutoCompletCalled = false;
      this.cleanSelectsAutoComplet(typeSearch);
    }

    this.isAutoCompletCalled = false;
  }

  cleanSelectsAutoComplet(typeSearch: TypeSearch) {

    if (this.formWasSubmited) {
      return;
    }

    if(typeSearch !== TypeSearch.CnpjCpf) {
      this.mySelectCnpjCpfField.reset();
    }

    if (typeSearch !== TypeSearch.Code) {
      this.mySelectCodeField.reset();
    }

    if (typeSearch !== TypeSearch.Name) {
      this.mySelectNameField.reset();
    }
  }

  cleanObjects(){

    this.filteredOptions = [];
    this.isLoadingPending.splice(this.isLoadingPending.indexOf(true), this.isLoadingPending.length - 1);
    this.havePortfolios = true;
    this.showPortfolios = false;
    this.isLoading = false;
    this.isChangeObject = true;
  }

  threatFinalizePortfoliosRequest(): void {

    this.isLoading = false;
    this.isLoadingPending.shift();

    if (this.isLoadingPending.length > 0) {
      this.isLoading = true;
    }

    if ((Array.isArray(this.filteredOptions) && this.filteredOptions.length > 0) ||
    (this.isLoadingPending.length > 0 || this.isChangeObject)) {
      this.havePortfolios = true;
    } else {
      this.havePortfolios = false;
    }
  }

  validatePortfoliosRequest(params: any, typeSearch: string) {

    if (params && typeof params === 'string' && params.trim().length > 2) {

      this.isLoadingPending.push(true);

      return this.occurenceService.getPortfoliosBySearch(String(params), typeSearch).pipe(
        finalize(() => {
          this.isAutoCompletCalled = true;
          this.threatFinalizePortfoliosRequest();
        }),
        catchError(
          (err) => {
            return of([]);
          }
        )
      );
    } else {
      return this.threatInvalidPortfoliosRequest(params);
    }
  }

  threatInvalidPortfoliosRequest(param: any): Observable<PortfolioAutoComplete[]> {
    this.isLoading = false;
    return of([]);
  }

  threatNotFoundPortfolio(disableNamePortfolio?: boolean): void {
    if (disableNamePortfolio) {
      if (!this.formWasSubmited) {
        this.mySelectNameField.setValue(null);
        this.mySelectCnpjCpfField.setValue(null);
        this.mySelectCodeField.setValue(null);
      }
      this.dataForm.get('fName').setValue(null);
      this.dataForm.get('fCpfCnpj').setValue(null);
      this.dataForm.get('fCode').setValue(null);
    }
    else {
      this.dataForm.get('fName').setValue(this.mySelectNameField.value);
      this.mySelectNameField.setValue(this.dataForm.get('fName').value);
    }
  }

  getField(fieldName: string): FormControl {
    return this.dataForm.get(fieldName) as FormControl;
  }

  fieldIsValid(fieldName: string): boolean {
    const field = this.getField(fieldName);
    return field.invalid && (this.mySelectCnpjCpfField.dirty || this.mySelectCnpjCpfField.touched || this.mySelectNameField.dirty || this.mySelectNameField.touched);
  }

  onlyNumbers(num) {
    const er = /[^\d]+/g;
    er.lastIndex = 0;
    if (er.test(num)) {
      num = num.replace(/[^\d]+/g, '');
    }
    return num;
  }

  selectPortfolio(event: any): void {
    let objSelected = event.option.value;
    //TO DO criar um método separado para validar cpf vindo da base
    if (objSelected){
      this.isValueAutoComplete = true;
      if(objSelected.name && objSelected.cnpj && objSelected.code && objSelected.id && !OccurencesService.cpfCnpjValidator(objSelected.cnpj)){
        this.utils.setValuePropertyHTML('mySelectNameField', '');
        this.utils.setValuePropertyHTML('mySelectCnpjCpfField', '');
        this.utils.setValuePropertyHTML('mySelectCodeField', '');
        objSelected = '';
        this.showLoading = false;
        this._snackbarService.showSnackbar('Carteira selecionada possui CNPJ/CPF inválido.', 'OK');
      }
      
      if (objSelected.name) {
        this.utils.setValuePropertyHTML('mySelectNameField', objSelected.name);
        this.dataForm.get('fName').setValue(objSelected.name);
      }
      if (objSelected.cnpj) {
        this.utils.setValuePropertyHTML('mySelectCnpjCpfField', objSelected.cnpj);
        this.dataForm.get('fCpfCnpj').setValue(objSelected.cnpj);
      }
      if (objSelected.code) {
        this.utils.setValuePropertyHTML('mySelectCodeField', objSelected.code);
        this.dataForm.get('fCode').setValue(objSelected.code);
      }
      if (objSelected.id) {
        this.dataForm.get('fundNumber').setValue(objSelected.id);
      }       
      this.showLoading = false;
    }
  }

  getOptionLabel(option) {
    if (option) {
      return option.name;
    }
  }

  disableFields() {
    //Autocomplete
    this.mySelectNameField.disable();
    this.mySelectCodeField.disable();
    this.mySelectCnpjCpfField.disable();
    //Form
    this.dataForm.get('fName').disable();
    this.dataForm.get('fCpfCnpj').disable();
    this.dataForm.get('fCode').disable();
  }

}
